$(document).ready(function () {
    if ($('.js-catalogue-download').length > 0) {
        var globalHeader = $('header.global'),
            mainNavigationList = $('nav.top');

        positionCatalogueDownload();
        $(window).resize(function () {
            positionCatalogueDownload();
        });
    }

    function positionCatalogueDownload() {
        var $catalogueDownload = $('.js-catalogue-download'),
            windowWidth = $(window).width();

        if (windowWidth <= 900) {
            $catalogueDownload.insertAfter(globalHeader);
        } else if (windowWidth > 900) {
            $catalogueDownload.appendTo(mainNavigationList);
        }
    }
});